import immutableStore from 'alt-utils/lib/ImmutableUtil';
import immutable from 'immutable';

import alt from 'components/Dispatcher';
import FileUploadScorecardActions from 'actions/scorecards/FileUploadScorecardActions';
import FileUploadScorecardSource from 'sources/scorecards/FileUploadScorecardSource';
import Scorecard from 'records/Scorecard';
import ComponentUtils from 'components/ComponentUtils';
import camelize from 'camelize';

/**
 * Store info about all the scorecards in a FileUpload object using Python endpoints such as
 * /api/v1/file/{id}/scorecards
 *
 * And also some Kotlin endpoints such as
 * /scorecard/results/{type}/{id}
 */
@immutableStore
class FileUploadScorecardStore {
  constructor() {
    this.state = immutable.Map({
      // scorecards maps FileUpload.id values to lists of Scorecard
      // Map<FileUploadId, List<Scorecard>>
      scorecards: immutable.Map(),
      scorecardResults: immutable.Map(),
    });
    this.bindActions(FileUploadScorecardActions);
    this.registerAsync(FileUploadScorecardSource);
    this.utils = new ComponentUtils();
  }

  /**
   * Fetch all the scorecards inside a FileUpload object
   * @param {string} fileUploadId A FileUpload.id value
   */
  onFetchScorecards(fileUploadId) {
    setImmediate(() => {
      this.getInstance().fetchScorecards(fileUploadId);
    });
  }

  /**
   * Fetch scorecard results for a FileUpload object
   * @param {string} fileUploadId A FileUpload.id value
   */
  onFetchScorecardResults(fileUploadId) {
    setImmediate(() => {
      this.getInstance().fetchScorecardResults(fileUploadId);
    });
  }
  /**
   * Update this.state.get('scorecards') using a server-side response object
   * @param fileUploadId id of the file upload.
   * @param scorecards scorecards from the server.
   */
  updateScorecards(fileUploadId, scorecards) {
    const localScorecards = immutable
      .List(scorecards.map(scorecard => new Scorecard(camelize(scorecard))))
      .sortBy(scorecard => scorecard.name);
    this.setState(this.state.setIn(['scorecards', fileUploadId], localScorecards));
  }

  /**
   * Update this.state.get('scorecardResults') using a server-side response object
   */
  updateScorecardResults(fileUploadId, scorecardResults) {
    this.setState(
      this.state.setIn(['scorecardResults', fileUploadId], immutable.List(scorecardResults))
    );
  }

  /**
   * Update this.state.get('scorecards') using a server-side response
   * @param  {object} data A {args, response} object
   */
  onFetchScorecardsSuccess(data) {
    this.updateScorecards(data.args[0], data.response.data.scorecards);
  }

  /**
   * Update this.state.get('scorecardResults') using a server-side response
   * @param  {object} data A {args, response} object
   */
  onFetchScorecardResultsSuccess(data) {
    this.updateScorecardResults(data.args[0], data.response.data);
  }

  /**
   * Similar to onFetchScorecardsSuccess(data), we update this.state.get('scorecards')
   * using a server-side response
   * @param  {object} data A {args, response} object
   */
  onSubmitScorecardResultsSuccess(data) {
    const fileUploadId = data.args[0];
    const scorecards = data.response.data.scorecards;
    this.updateScorecards(fileUploadId, scorecards);
  }
}

export default alt.createStore(FileUploadScorecardStore, 'FileUploadScorecardStore');
